import { GameLaunchStatus } from "@onmo/eon-streaming";
import { PcGameStatus } from "../types/gamePlay";

export const disconnectedStatuses = [
  GameLaunchStatus.STATUS_GAMERUNNING_DISCONNECTED,
  GameLaunchStatus.STATUS_LAUNCHING_DISCONNECTED,
];

export const postHandoffStatuses = [
  GameLaunchStatus.STATUS_LAUNCHING,
  GameLaunchStatus.STATUS_GAMERUNNING,
];

export const PCGameActionRequiredStatuses = [
  GameLaunchStatus.STATUS_STEAMLOGIN,
  GameLaunchStatus.STATUS_EULA,
  GameLaunchStatus.STATUS_SETLAUNCHEROPTIONS,
  GameLaunchStatus.STATUS_LAUNCHER_UP,
];

export const PCInGameBlockingStatuses = [
  GameLaunchStatus.STATUS_NOGAMELICENSE,
  GameLaunchStatus.ERROR,
  GameLaunchStatus.STATUS_GAMEEXITED,
  GameLaunchStatus.STATUS_GAMELAUNCH_TIMEOUT,
  GameLaunchStatus.ERR_NOTACTIVE,
  GameLaunchStatus.STATUS_UPDATEDETECTED,
];

export const PCGamePersistentStatuses = [
  GameLaunchStatus.STATUS_EULA,
  GameLaunchStatus.STATUS_GAMELAUNCHING,
  GameLaunchStatus.STATUS_LAUNCHER_UP,
  GameLaunchStatus.STATUS_CONSENTNOCLOUDSYNC,
];

export type LoadingStatuses = "Error" | "Installing" | "Launching" | "Done";

export const PC_SYSTEM_EVENT_MAP_VALUE: Record<
  "framerate" | "video_bitrate" | "audio_bitrate",
  (data: string | number) => Partial<PcGameStatus>
> = {
  framerate: (data) => ({ frameRate: Number(data) }),
  video_bitrate: (data) => ({ videoBitrate: Number(data) / 1000 }),
  audio_bitrate: (data) => ({ audioBitrate: Number(data) / 1000 }),
};

export const EON_STREAMING_SERVER_ENDPOINT =
  import.meta.env.VITE_EON_STREAMING_SERVER_ENDPOINT ||
  "https://eon-es.onmostealth.com";

export const GAME_LOADING_TIP_KEYS = [
  "LoadingTip_Graphics Settings: Optimized for You: We’ve pre-configured the graphics for the best balance of quality and performance. Changing them may affect stability.",
  "LoadingTip_Exiting Full Screen: To exit full screen, hold Esc on your computer or hold the ☰ options button on your controller to open the Console Overlay.",
  "LoadingTip_Opening Side Menu: To open the Console Overlay press Shift + F12 on your keyboard, hold the ☰ options button on your controller or tap the little ☰ on the left side of the screen on mobile.",
  "LoadingTip_Network Quality: For the most stable experience, use a 5GHz Wi-Fi band or a wired Ethernet connection.",
  "LoadingTip_Install & Play: Titles in this section require ownership on Steam to install and play on your private cloud instance.",
  "LoadingTip_Seamless Play: Start on your PC, finish on your phone. Just launch the game on your new device to pick up right where you left off.",
  "LoadingTip_Local Multiplayer: Play local multiplayer games by connecting multiple controllers to your device.",
  "LoadingTip_Online Multiplayer: You can enjoy online multiplayer games with your friends.",
  "LoadingTip_Stay active: To save resources, sessions may automatically close after a period of inactivity. Don't forget to save your game!",
  "LoadingTip_Reduce Lag: Ensure your TV or Monitor is set to 'Game Mode' to minimize input latency while playing.",
  "LoadingTip_Smooth Streaming: Close heavy background downloads or streaming apps on your local network for a stutter-free experience.",
  "LoadingTip_Queue Time: If servers are busy, you may be placed in a queue. Your position and wait time will be shown before your session starts.",
  "LoadingTip_Reconnect Quickly: If you disconnect, you have a short window to reconnect and resume your session.",
  "LoadingTip_Link Your Account: Some games require a connected game store account before you can play.",
  "LoadingTip_Avoid Downloads: Do not download or install additional content during your session. This may cause instability or session termination.",
  "LoadingTip_Stay in Game: Launching other games from the store during a session is not supported and may end your session.",
  "LoadingTip_Account Usage: Using shared or public game store accounts may lead to save issues.",
];

export const GAME_LOADING_STATUS_KEYS = [
  "GamePlay_Launching your Smart Console...",
  "GamePlay_Allocating private compute...",
  "GamePlay_Initializing your stream...",
  "GamePlay_Connecting to your session...",
];

export const TIME_CALL_GAME_QUEUE_STATUS = 30000;

export const GAME_QUEUE_READY_TIMEOUT = 300_000;

export const STREAM_CONNECT_TIMEOUT_MS = 60000;

export const JOIN_GAME_PLAY_MESSAGES = {
  gamePlayQueued: "GAME_PLAY_QUEUED",
};

export const GAME_TO_LINK_STEAM = "842962ce-490a-40df-8df1-b41476d4ed7f";

export const IGNORE_TOAST_MESSAGE = ["Shutting Down", "Your Game Is Installed"];
